import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://mnpcjcfvqnpivmhnfero.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1ucGNqY2Z2cW5waXZtaG5mZXJvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU4MjgyOTksImV4cCI6MjA3MTQwNDI5OX0.3xd6Aw-u92GxTfK_mZVLNeyMcNBqD1xBnDc6833_Rus';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
